// ClientHistoryPanel — week-by-week history navigator for the client view.
// v1: simple deep-link list. When only one week exists, shows an empty state.

import React from "react";
import { Link } from "react-router-dom";

const ClientHistoryPanel = ({ clientId, availableYearWeeks, selectedYearWeek, history }) => {
    const weeks = Array.isArray(availableYearWeeks) ? [...availableYearWeeks].sort().reverse() : [];
    if (weeks.length <= 1) {
        return (
            <div className="card-flat p-6" data-testid="client-history-empty">
                <div className="eyebrow">History</div>
                <h3 className="display text-base mt-1">Single week available</h3>
                <p className="text-xs text-[hsl(var(--mute))] mt-2 leading-relaxed">More history will appear once additional client weeks are published.</p>
                {weeks.length === 1 && (
                    <p className="text-[11px] text-[hsl(var(--ink-soft))] mt-2 num">Current: {weeks[0]}</p>
                )}
            </div>
        );
    }
    return (
        <div className="card-flat p-6" data-testid="client-history">
            <div className="eyebrow">History</div>
            <h3 className="display text-base mt-1">Jump to a published week</h3>
            <p className="text-[11px] text-[hsl(var(--mute))] mt-1">{weeks.length} weeks available.</p>
            <ul className="mt-4 space-y-1.5">
                {weeks.map((yw) => {
                    const active = yw === selectedYearWeek;
                    const summary = history?.weeklyLensByWeek?.[yw]?.executiveClientSummary;
                    return (
                        <li key={yw}>
                            <Link
                                to={`/client/${clientId}/${yw}`}
                                data-testid={`history-week-${yw}`}
                                className={`flex items-center gap-3 px-2 py-1.5 -mx-2 rounded-sm text-xs ${active ? "bg-[hsl(var(--accent-soft))] text-[hsl(var(--accent-ink))]" : "hover:bg-[hsl(var(--surface-sunken))] text-[hsl(var(--ink-soft))]"}`}
                            >
                                <span className="num font-medium w-20 flex-none">{yw}</span>
                                {summary && <span className="truncate text-[11px] text-[hsl(var(--mute))]">{summary}</span>}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default ClientHistoryPanel;
